import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import "./css/TermsOfService.css";

const TermsOfService = () => {
  const pageTitle = "Terms of Service | Dhandha Karle";
  const metaDescription =
    "Review the Terms of Service for using Dhandha Karle’s POS, inventory management, and invoice generator. Understand your rights and responsibilities.";

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta
          name="keywords"
          content="terms of service, Dhandha Karle, POS software, invoice generator, business software India, user agreement"
        />
        <meta name="author" content="Dhandha Karle Team" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dhandhakarle.com/terms" />
        <meta
          property="og:image"
          content="https://dhandhakarle.com/og-image.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <link rel="canonical" href="https://dhandhakarle.com/terms" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <section className="terms-of-service">
        <div className="terms-container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: April 11, 2025</p>

          <p>
            Welcome to Dhandha Karle. These Terms of Service (“Terms”) govern your
            use of our website, software, and services, including our restaurant
            POS, inventory management system, and free invoice generator
            (collectively, “Services”). By accessing or using our Services, you
            agree to these Terms.
          </p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By using our Services, you confirm that you are at least 18 years old
            and have the legal capacity to enter into this agreement. If you are
            using the Services on behalf of a business, you represent that you have
            the authority to bind that business.
          </p>

          <h2>2. Use of Services</h2>
          <p>You agree to use the Services only for lawful purposes and to:</p>
          <ul>
            <li>
              Provide accurate information when registering or using our tools.
            </li>
            <li>
              Maintain the security of your account by not sharing credentials.
            </li>
            <li>
              Not attempt to reverse-engineer, hack, or disrupt our Services.
            </li>
          </ul>

          <h2>3. Account Responsibilities</h2>
          <p>
            You are responsible for all activities under your account. Notify us
            immediately at{" "}
            <a href="mailto:support@dhandhakarle.com">
              support@dhandhakarle.com
            </a>{" "}
            if you suspect unauthorized access.
          </p>

          <h2>4. Payments and Subscriptions</h2>
          <p>
            Some Services require payment (e.g., premium POS plans). You agree to:
          </p>
          <ul>
            <li>Pay all applicable fees as described on our website.</li>
            <li>
              Provide valid payment information and authorize recurring charges
              for subscriptions.
            </li>
            <li>
              Understand that fees are non-refundable unless otherwise stated.
            </li>
          </ul>

          <h2>5. Intellectual Property</h2>
          <p>
            All content, software, and designs in our Services are owned by Dhandha
            Karle or our licensors. You may not copy, modify, or distribute our
            intellectual property without permission.
          </p>

          <h2>6. User Content</h2>
          <p>
            You retain ownership of data you input (e.g., invoices, inventory
            records). By using our Services, you grant us a non-exclusive license
            to process and store this data to provide the Services.
          </p>

          <h2>7. Termination</h2>
          <p>
            We may suspend or terminate your access if you violate these Terms. You
            may cancel your account at any time by contacting us. Upon
            termination, you must cease using the Services.
          </p>

          <h2>8. Disclaimer of Warranties</h2>
          <p>
            Our Services are provided “as is.” We do not guarantee that they will
            be error-free or uninterrupted. Dhandha Karle is not responsible for
            the accuracy or legal compliance of invoices generated.
          </p>

          <h2>9. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Dhandha Karle is not liable for
            indirect, incidental, or consequential damages arising from your use of
            the Services.
          </p>


          <h2>10. Changes to Terms</h2>
          <p>
            We may update these Terms periodically. Changes will be posted on this
            page, and continued use of the Services constitutes acceptance.
          </p>

          <h2>11. Contact Us</h2>
          <p>
            For questions about these Terms, please contact:
          </p>
          <p>
            Dhandha Karle Team
            <br />
            Email:{" "}
            <a href="mailto:support@dhandhakarle.com">
              support@dhandhakarle.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;